import React, { useContext } from "react";
import { AuthContext } from "../../services/AuthContext";

import "./LExpandedPlayer.css";
import { useAlert } from "../../services/AlertProvider";
import usePlayerUtils from "../../hooks/usePlayerUtils";

function LExpandedPlayer({ wrapChildClick, listRef, onTabChevron, expanded }) {
    const {
        audioRef,
        currentTrack,
        nowPlaying,
        playbackState,
        audioTimeMs,
        setCurrentTimeSec,
        durationPercent,
        setManualTrack,
        setIsSeeking,
        setTimeShiftOffsetSec,
        timeShiftOffsetSec,
    } = usePlayerUtils();

    const { isLoggedIn, setUserModalOpen } = useContext(AuthContext);

    const { showAlert } = useAlert();

    const startedAt = currentTrack?.startedAt;

    //const durationPercent = getDurationPercent(currentTrack?.startedAt, currentTrack?.duration);

    const handleLiveBtn = (e) => {
        const audio = audioRef.current;
        if (!audio) return;

        setTimeShiftOffsetSec(0);

        audio.currentTime = timeShiftOffsetSec + audio.currentTime;
        setCurrentTimeSec(timeShiftOffsetSec + audio.currentTime);

        handleResumeLive();
    }

    const handleResumeLive = () => {
        setIsSeeking(false);
        setManualTrack(null);
    };

    const isNext = (startedAt) => {
        if (playbackState !== "playing" || audioTimeMs <= 0 || startedAt === null || startedAt === "") { return false }

        const startedAtNext = startedAt
        const staredAtMs = new Date(startedAtNext).getTime();
        const isNext = staredAtMs > audioTimeMs + timeShiftOffsetSec * 1000;

        return isNext
    }

    const historySeek = (staredAt, duration) => {
        const { maxTimeShiftSeconds, currentLiveTime, history } = nowPlaying || {};
        if (!staredAt || !duration || staredAt === "" || duration === "") return

        if (isNext(staredAt)) {
            showAlert("You can't play this song yet!")
            return;
        }

        const audio = audioRef.current;
        if (!audio || !maxTimeShiftSeconds || !currentLiveTime || !history?.length) return;

        // if (!isLoggedIn) {
        //     setUserModalOpen(true);
        //     return;
        // }

        const staredAtMs = new Date(staredAt).getTime();

        const bufferStartMs = audioTimeMs - (maxTimeShiftSeconds - timeShiftOffsetSec) * 1000;
        const realCurrentTime = timeShiftOffsetSec + audio.currentTime;
        const percent = (staredAtMs - bufferStartMs) / (maxTimeShiftSeconds * 1000);
        const desiredMs = realCurrentTime - maxTimeShiftSeconds + percent * maxTimeShiftSeconds;

        if (desiredMs <= 0) {
            showAlert("You can't play this song anymore!")
            return;
        }

        const newOffset = realCurrentTime - desiredMs;
        setTimeShiftOffsetSec(newOffset);

        audio.currentTime = desiredMs;
        setCurrentTimeSec(desiredMs);

        const currentSong = history.find(song => {
            const start = new Date(song.startedAt).getTime();
            return staredAtMs >= start;
        });

        if (currentSong) {
            setManualTrack(currentSong || null);
            setIsSeeking(true);
        }
    };

    const getProgressColor = (percent) => {
        const p = Math.min(Math.max(percent, 0), 1);

        const redBase = p < 0.5 ? 255 : Math.round(255 - (p - 0.5) * 2 * 255);
        const greenBase = p < 0.5 ? Math.round(p * 2 * 255) : 255;
        const blueBase = 0;

        const grayFactor = 0.6; // higher = more grayish
        const red = Math.round(redBase * (1 - grayFactor) + 100 * grayFactor);
        const green = Math.round(greenBase * (1 - grayFactor) + 100 * grayFactor);
        const blue = Math.round(blueBase * (1 - grayFactor) + 100 * grayFactor);

        return `linear-gradient(
        rgba(${red},${green},${blue},0.4),
        rgba(${red},${green},${blue},0.08),
        rgba(${red},${green},${blue},0.4)
        )`;
    };

    const expandedPlayerHistory = () => {
        const { history } = nowPlaying || {};
        const songHistory = history || [];

        const liveBtnClassName = timeShiftOffsetSec <= 0 || playbackState === "stopped" ? "l-live-btn-disabled l-live-button" : "l-live-button";

        return (
            <div className="l-expanded-history-main">
                {expanded &&
                    <div className="l-chevron-close-player">
                        <button className="l-chevron-btn" onClick={onTabChevron}>
                            <i className="fa-solid fa-chevron-right"></i>
                        </button>
                    </div>}
                <button className={liveBtnClassName} onClick={wrapChildClick(() => handleLiveBtn())} disabled={timeShiftOffsetSec <= 0 || playbackState === "stopped"} >
                    <div className="l-live-text">GO LIVE</div>
                </button>
                <div className="l-expanded-history-title">
                    <div className="l-histoty-title-main">
                        <div>HISTORY</div>
                    </div>
                    <div className="l-histoty-title-second">
                        <div>TAP TRACK TO PLAY</div>
                    </div>
                </div>
                <div className="l-expanded-history-contetnt">
                    <div className="l-inner-history-content">
                        <div className="l-contetnt-list">
                            <ul
                                ref={listRef}
                                className="l-scrollable-list" >
                                {songHistory.map((song, idx) => {
                                    const prevSong = songHistory[idx - 1];
                                    const isLastInPlaylist =
                                        !prevSong || song.playlistName !== prevSong.playlistName;

                                    return (
                                        <React.Fragment key={idx}>
                                            {isLastInPlaylist && song.playlistName && (
                                                <li className="l-playlist-separator">
                                                    <span className="l-separator-label">{song.playlistName}</span>
                                                </li>
                                            )}
                                            <li className="l-track-item">
                                                {(playbackState === "playing" || playbackState === "paused") && startedAt === song.startedAt
                                                    && <>
                                                        <div
                                                            className="l-list-song-filled"
                                                            style={{
                                                                width: `${durationPercent() * 100}%`,
                                                                background: playbackState === "playing"
                                                                    ? getProgressColor(durationPercent())
                                                                    : "linear-gradient(rgba(128, 128, 128, 0.459), rgba(128, 128, 128, 0.093), rgba(128, 128, 128, 0.459))",
                                                            }}>

                                                        </div>
                                                        <div className="l-list-song-end" style={{ left: `${durationPercent() * 100}%` }}></div>
                                                    </>}
                                                <button className="l-list-song-link l-contetnt-item" onClick={wrapChildClick(() => historySeek(song.startedAt, song.duration))} >
                                                    <div className="l-contetnt-item-track">
                                                        <div className="l-contetnt-item-title">{song.title}</div>
                                                        <div className="l-contetnt-item-artist">{song.artist}</div>
                                                    </div>
                                                    <div className="l-contetnt-item-play">
                                                        {isNext(song.startedAt)
                                                            ? <div className="l-up-next">UP NEXT</div>
                                                            : playbackState === "playing" && startedAt === song.startedAt
                                                                ? <>
                                                                    <div className="l-contetnt-item-play-duration">{song.duration}</div>
                                                                    <i className="fas fa-play"></i>
                                                                </>
                                                                : playbackState === "paused" && startedAt === song.startedAt &&
                                                                <>
                                                                    <div className="l-contetnt-item-play-duration">{song.duration}</div>
                                                                    <i className="fas fa-pause"></i>
                                                                </>}
                                                    </div>
                                                </button>
                                            </li>
                                        </React.Fragment>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        );
    };

    return (
        <div className="l-player-expanded" style={{ opacity: 1 }} >
            {expandedPlayerHistory()}
        </div>
    );
};

export default React.memo(LExpandedPlayer);
